/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvTranBySiteRptData { 
    locationIdentifier?: string | null;
    siteName?: string | null;
    itemNumber?: string | null;
    itemDescription?: string | null;
    inventoryDisplayUOfM?: string | null;
    expDate?: string | null;
    invTranPrevious?: number;
    invTranIN?: number;
    invTranGPAdj?: number;
    invTranOUT?: number;
    invTranADJ?: number;
    invTranCurrent?: number;
    readonly itemDescriptionDisplay?: string | null;
    readonly invTranPreviousDisplay?: string | null;
    readonly invTranINDisplay?: string | null;
    readonly invTranOUTDisplay?: string | null;
    readonly invTranADJDisplay?: string | null;
    readonly invTranCurrentDisplay?: string | null;
}

